import React from "react";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaLinkedin,
} from "react-icons/fa";

import "./Footer.css";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* Company */}

        <div className="footer-column">

          <img
            src="/eforum_logo.png"
            alt="E-Forum"
            className="footer-logo"
          />

          <h2>E-FORUM</h2>

          <p>
            Building scalable enterprise software solutions,
            offshore development centers, managed IT services,
            digital transformation and technology consulting
            for businesses worldwide.
          </p>

        </div>

        {/* Quick Links */}

        <div className="footer-column">

          <h3>Quick Links</h3>

          <ul>

            <li><a href="/">Home</a></li>

            <li><a href="/services">Services</a></li>

            <li><a href="/technology">Technology</a></li>

            <li><a href="/industries">Industries</a></li>

            <li><a href="/resources">Resources</a></li>

            <li><a href="/careers">Careers</a></li>

            <li><a href="/about">About Us</a></li>

          </ul>

        </div>

        {/* Services */}

    {/* Services */}

<div className="footer-column">

  <h3>Services</h3>

  <ul>

    <li>
      <Link to="/services/product-development">
        Product Development
      </Link>
    </li>

    <li>
      <Link to="/services/product-maintenance">
        Product Maintenance
      </Link>
    </li>

    <li>
      <Link to="/services/it-staffing">
        IT Staffing
      </Link>
    </li>

    <li>
      <Link to="/services/training">
        Training
      </Link>
    </li>

    <li>
      <Link to="/services/managed-it-services">
        Managed IT Services
      </Link>
    </li>

  </ul>

</div>
        {/* Contact */}

        <div className="footer-column">

          <h3>Contact Us</h3>

          <div className="footer-contact">

            <p>

              <FaEnvelope className="footer-icon" />

              info@eforumsystems.com

            </p>

            <p>

              <FaPhoneAlt className="footer-icon" />

              +91 9422110467

            </p>

            <p>

              <FaMapMarkerAlt className="footer-icon" />

              Nagpur, Maharashtra, India

            </p>

            <a
              href="https://www.linkedin.com/company/e-forum-systems/"
              target="_blank"
              rel="noopener noreferrer"
              className="linkedin-link"
            >

              <FaLinkedin className="footer-icon" />

              Follow us on LinkedIn

            </a>

          </div>

        </div>

        {/* Google Map */}

        <div className="footer-column">

          <h3>Find Us</h3>

          <div className="footer-map">

            <iframe
              title="E-Forum Location"
              src="https://www.google.com/maps?q=Nagpur,Maharashtra&output=embed"
              width="100%"
              height="230"
              style={{
                border: 0,
                borderRadius: "15px",
              }}
              loading="lazy"
              allowFullScreen
            />

          </div>

        </div>

      </div>

      {/* Bottom Footer */}

      <div className="footer-bottom">

  <p>
    © 2026 E-Forum Software Solutions. All Rights Reserved.
  </p>

  <div className="footer-bottom-links">

    <Link to="/privacy-policy">
      Privacy Policy
    </Link>

    <span>|</span>

    <Link to="/terms-and-conditions">
      Terms & Conditions
    </Link>

  </div>

</div>   

</footer>
  );
}
